import { render, staticRenderFns } from "./Questionbank.vue?vue&type=template&id=4db97498&scoped=true"
import script from "./Questionbank.vue?vue&type=script&lang=js"
export * from "./Questionbank.vue?vue&type=script&lang=js"
import style0 from "./Questionbank.vue?vue&type=style&index=0&id=4db97498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db97498",
  null
  
)

export default component.exports